import { cva } from 'class-variance-authority';

const stepperKnobTextStylesSAG = cva(
  [
    'text-[#000028]',
    'dark:text-white',
    'text-base',
    'font-normal',
    'select-none',
    'truncate',
    'data-[status=done]:text-[#007993]',
    'dark:data-[status=done]:text-[#00CCCC]',
    'data-[status=error]:text-[#D72339]',
    'dark:data-[status=error]:text-[#FF7687]',
    'data-[status=active]:text-[#005159]',
    'dark:data-[status=active]:text-[#00FFB9]',
    'data-[status=default]:text-[#000028]',
    'dark:data-[status=default]:text-[#FFFFFF]',
    'data-[status=disabled]:text-[#B3B3BE]',
    'dark:data-[status=disabled]:text-[#737389]',
  ],
  {
    variants: {
      orientation: {
        vertical: ['text-left', 'ml-2'],
        horizontal: ['text-center', 'mt-2'],
      },
    },
  },
);

const stepperKnobTextStylesSHS = cva(
  [
    'text-[#333333]',
    'dark:text-white',
    'text-base',
    'font-normal',
    'select-none',
    'truncate',
    'data-[status=done]:text-[#cf4b00]',
    'dark:data-[status=done]:text-[#cf4b00]',
    'data-[status=error]:text-[#e7001d]',
    'dark:data-[status=error]:text-[#e7001d]',
    'data-[status=active]:text-[#ec6602]',
    'dark:data-[status=active]:text-[#ec6602]',
    'data-[status=default]:text-[#666666]',
    'dark:data-[status=default]:text-[#ffffff]',
    'data-[status=disabled]:text-[#ededed]',
    'dark:data-[status=disabled]:text-[#ededed]',
  ],
  {
    variants: {
      orientation: {
        vertical: ['text-left', 'ml-2'],
        horizontal: ['text-center', 'mt-2'],
      },
    },
  },
);

export { stepperKnobTextStylesSAG, stepperKnobTextStylesSHS };
